// import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import { Card, CardContent, CardHeader, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useEffect } from "react";
import planningService from "../../services/planning.service";

export default function PlanningSummary(props) {

    const { t } = useTranslation()
    const { dataSummary, datasPlanning, checkAdd } = props;
    const [summary, setSummary] = React.useState([]);
    useEffect(() => {
        mappingSum()
    }, [dataSummary, datasPlanning]);
    useEffect(() => {
        mappingSum()
    }, [checkAdd]);
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    let sumScore = (data) => {
        let totals = 0
        data.rb_condition.map((data) => { totals = totals + calculateScore(data) })
        return totals
    }
    let calculateSum = (datas) => {
        let data = summary
        let summarys = eval(datas.sum)
        let sum = Number.isNaN(Number(summarys)) ? 0 : Math.round(summarys * 100) / 100
        return sum.toFixed(2)
    }
    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
        return scores
    }
    let sumScoreAccumulateUse = (data) => {
        let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
        for (let index = 0; index <= data.rb_condition.length - 1; index++) {
            totals = totals + Number(calculateScore(data.rb_condition[index]))
        }
        return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    }
    const mappingSum = () => {
        if (datasPlanning !== undefined && datasPlanning !== null && datasPlanning !== "" && datasPlanning.length > 0 && dataSummary !== undefined && dataSummary !== null && dataSummary.length > 0) {
            var typeData = []
            var data = {}
            for (let index = 0; index <= datasPlanning.length - 1; index++) {
                for (let indexs = 0; indexs <= dataSummary.length - 1; indexs++) {
                    data[datasPlanning[index].code] = Number(sumScoreAccumulateUse(datasPlanning[index]));
                }
            }
            setSummary(data);
        }
    }

    return (
        <Grid container item>
            <Grid container spacing={4}>
                <Grid item lg={12} xs={12}>
                    {/* <Card sx={{ height: 1 }}> */}
                    {/* <CardHeader variant="summary"
                            title={t('planning.label.ruleAndCondition')}
                        /> */}
                    <CardContent>
                        <TableContainer>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{ borderBottom: "0.5px solid #E4E4E4" }}>
                                        <TableCell><Typography variant="label"> {t('planning.label.ruleAndCondition')}</Typography></TableCell>
                                        <TableCell sx={{ textAlign: "center" }}><Typography variant="label"> {t('planning.label.low')}</Typography></TableCell>
                                        <TableCell sx={{ textAlign: "center" }}><Typography variant="label"> {t('planning.label.high')}</Typography></TableCell>
                                        <TableCell sx={{ textAlign: "center" }}><Typography variant="label"> {t('planning.label.portion')}</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataSummary !== undefined && dataSummary !== null && dataSummary.length > 0 ?
                                        dataSummary.map(item => (
                                            <TableRow>
                                                <TableCell component="th" scope="row" sx={{ paddingBottom: "3px", "border": "none" }}>
                                                    <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.description, "-")}</Typography>
                                                </TableCell>
                                                <TableCell component="th" scope="row" sx={{ paddingBottom: "3px", textAlign: "center", "border": "none" }}>
                                                    <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.min !== 0 ? item?.min : "-", "-")}</Typography>
                                                </TableCell>
                                                <TableCell component="th" scope="row" sx={{ paddingBottom: "3px", textAlign: "center", "border": "none" }}>
                                                    <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.max !== 0 ? item?.max : "-", "-")}</Typography>
                                                </TableCell>
                                                <TableCell component="th" scope="row" sx={{ paddingBottom: "3px", textAlign: "center", "border": "none" }}>
                                                    {item?.action === "error" ?
                                                        <Typography color={calculateSum(item) >= item?.min ? item?.max > 0 ? calculateSum(item) <= item?.max ? "#5DA196" : "#CC6058" : "#5DA196" : "#CC6058"} fontSize={16} lineHeight="21.86px">
                                                            {calculateSum(item) !== undefined && calculateSum(item) !== null && calculateSum(item) !== NaN ? calculateSum(item) : 0}
                                                        </Typography>
                                                        :
                                                        <Typography color={calculateSum(item) >= item?.min ? item?.max > 0 ? calculateSum(item) <= item?.max ? "#5DA196" : "#CC6058" : "#5DA196" : "#FFBF49"} fontSize={16} lineHeight="21.86px">
                                                            {calculateSum(item) !== undefined && calculateSum(item) !== null && calculateSum(item) !== NaN ? calculateSum(item) : 0}
                                                        </Typography>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )) : null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                    {/* </Card> */}
                </Grid>
            </Grid>
        </Grid>
    );
}
